import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostStocksDateParams, TypePostStocksDateResponse, TypeStockDate } from '~/types/stock.types';

const usePostStocksDate = () => {
  const endPoint = '/api-inventory/v1/third-parties/stocks/date';

  const postStocksDate = async (params: TypePostStocksDateParams) => {
    return axiosInstance
      .post<TypePostStocksDateResponse>(endPoint, {
        ...params,
      })
      .then(({ data: { data, pagination } }) => {
        return { data, pagination };
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postStocksDate };
};

export default usePostStocksDate;

const mockStockDate = (index: number, overrides: Partial<TypeStockDate> = {}): TypeStockDate => ({
  warehouseCode: 'GGM1',
  clusterName: '김포',
  zoneCode: 'Z01',
  locationName: `A-01-0${index}`,
  stockType: '가용',
  temperatureType: '냉장',
  manufactureDate: '2026-05-01',
  expiredDate: '2026-06-30',
  salesDeadLineDate: '2026-06-20',
  skuCode: `M000004076${String(index).padStart(2, '0')}`,
  alterCode: `88123123140${index}`,
  skuName: `(센터명)유통기한상품${index}`,
  totalQuantity: 300,
  availableQuantity: 250,
  allocationQuantity: 30,
  holdingQuantity: 10,
  defectiveQuantity: 10,
  ...overrides,
});

const stocksDateNormalResponse: TypePostStocksDateResponse = {
  data: [
    mockStockDate(1),
    mockStockDate(2, { stockType: '불용', expiredDate: '2026-05-25', salesDeadLineDate: '2026-05-20' }),
    mockStockDate(3, { manufactureDate: '', temperatureType: '상온', clusterName: '평택' }),
    mockStockDate(4, { skuName: '(센터명)이름이 아주 긴 유통기한 상품명 — 말줄임 확인용 긴 상품명 텍스트' }),
    mockStockDate(5, { temperatureType: '냉동', totalQuantity: 12000, availableQuantity: 12000 }),
  ],
  pagination: { listView: 100, listTotal: 5, cursor: 0 },
};

registerMockAPI<TypePostStocksDateResponse>({
  method: 'post',
  endpoint: '/api-inventory/v1/third-parties/stocks/date',
  label: '재고/유통기한별조회/재고목록',
  scenarios: [
    { name: '정상 응답', response: stocksDateNormalResponse },
    { name: '검색 결과 0건', response: { data: [], pagination: { listView: 100, listTotal: 0, cursor: 0 } } },
  ],
});
